import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RestApiService } from 'src/app/services/rest-api/rest-api.service';
import { StrategyInstrumentsFormService } from 'src/app/services/strategy-instruments-form.service';
import { ToastNotificationService } from 'src/app/services/toast-notification/toast-notification.service';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { map, take } from 'rxjs/operators'
import { UserService } from 'src/app/services/user/user.service';
import { ApiClientAccountOut, InstrumentDetailFullOut, ManagementTypesEnum } from 'src/app/services/rest-api/rest-api';
import { forkJoin } from 'rxjs';
import { LoginService } from 'src/app/services/login.service';

interface MergedApiData {
  instruments: InstrumentDetailFullOut[],
  client: ApiClientAccountOut;
}

@Component({
  templateUrl: './edit-instruments.component.html',
  styleUrls: ['./edit-instruments.component.scss'],
  standalone: false
})
export class EditInstrumentsComponent implements OnInit {
  public filtrationForm!: UntypedFormGroup;
  public editId: number | null = null;
  public editStrategyOrigin: string | null = null;

  public allInstruments: InstrumentDetailFullOut[] = [];
  public preloaders = {
    instruments: true,
    editStrategyForPMWithStrategies: false,
  };

  public constructor(
    public instrumentsService: StrategyInstrumentsFormService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private restApiService: RestApiService,
    private fb: UntypedFormBuilder,
    public toastService: ToastNotificationService,
    private loggerService: LoggerService,
    private userService: UserService,
    private loginService: LoginService,
  ) { }

  public ngOnInit(): void {
    //todo - handle StrategyInstrumentsFormService (without strategy data kick user to new strategy?)
    this.setupEditIdAndOriginIfPresent();
    this.redirectOnEmptyData();
  }

  private setupEditIdAndOriginIfPresent() {
    this.activatedRoute.paramMap.pipe(take(1)).subscribe(params => {
      const editId = params.get('editStrategyId');
      this.editStrategyOrigin = params.get('editOrigin');
      if (editId) (this.editId = parseInt(editId));
      this.loadAllAvailableInstruments();
    })
  }

  private loadAllAvailableInstruments(): void {
    const neccessaryInitReqests = [
      this.restApiService.getInstruments(),
      this.restApiService.getUserDetail(),
    ];

    forkJoin(neccessaryInitReqests).pipe(
      take(1),
      map(([ instruments, client ]) => ({ instruments, client } as MergedApiData)),
    ).subscribe({
        error: (error) => this.handleInstrumentsError(error),
        next: (data) => this.handleClientInstrumentsData(data),
    });
  }

  private handleClientInstrumentsData(apiData: MergedApiData): void {
    this.loginService.handleUserDetailsData(apiData.client, true);
    this.handleInstrumentsData(apiData.instruments);
  }

  private handleInstrumentsError(error: unknown): void {
    this.preloaders.instruments = false;
    this.loggerService.error(typeof error === 'function' ? error() : error);
    this.toastService.unknownApiError();
  }

  private handleInstrumentsData(data: InstrumentDetailFullOut[]): void {
    this.preloaders.instruments = false;
    this.allInstruments = data;
  }

  private redirectOnEmptyData(): void {
    if (!this.instrumentsService.selectedInstruments?.controls.length) {
      this.router.navigate(['/strategy/new']);
    }
  }

  public loadEditStrategyForPMWithStrategies(): void {
    if (this.userService.loggedUser?.managementType === ManagementTypesEnum.PORTFOLIO_MANAGEMENT) {
      this.preloaders.editStrategyForPMWithStrategies = true;
    }
  }
}
